export default {
  all: null,
  doctorsVectorLayer: undefined,
  styleCacheDoctor: [],
  doctors: null,
  supercluster: null,
  colors: {},
  hauptfach: 'Alle',
};
